import { useSplitPaymentFlow } from "~/hooks/use-split-payment-flow";
import { useCurrentTill } from "~/api/tills/hooks/use-till-current";
import { useEmployee } from "~/providers/store/employee";
import { useBasketContext } from "~/providers/store/basket/context";

import { BasketItem } from "./BasketItem";
import { CollectBasket } from "./CollectBasket";
import { BasketHeader } from "./basket-header";
import { BasketFooter } from "./basket-footer";

export const Basket = () => {
  const { isActive: isSplitPaymentActive } = useSplitPaymentFlow();

  const { data: till } = useCurrentTill();

  const productsInBasket = useBasketContext((state) => state.productsInBasket);

  const employeeData = useEmployee();
  const isUserAuthenticated = Boolean(
    employeeData.employeeCardHex || employeeData.employeeChildId
  );

  return (
    <div className="flex size-full flex-1 flex-col justify-between bg-background-primary">
      <BasketHeader />

      {till && till.type === "collect" && isUserAuthenticated ? (
        <CollectBasket />
      ) : null}

      <div className="flex flex-1 flex-col overflow-auto gradient-mask-b-90 scrollbar-hide">
        {productsInBasket.map((basketItem) => (
          <BasketItem
            basketProductId={basketItem.basketId}
            disabled={isSplitPaymentActive}
            discountPercentage={basketItem.discountPercentage}
            key={basketItem.basketId}
            options={basketItem.options}
            productName={basketItem.name}
            quantity={basketItem.quantity}
            stampCardRuleId={basketItem.stampCardRuleId}
            totalDisplayPrice={basketItem.totalDisplayPrice}
            totalOriginalDisplayPrice={basketItem.totalOriginalDisplayPrice}
            depositDisplayPrice={basketItem.depositDisplayPrice}
            variantDepositDisplayPrices={basketItem.variantDepositDisplayPrices}
            discount={basketItem.discount}
          />
        ))}
      </div>

      <BasketFooter />
    </div>
  );
};
